<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Top Header -->
    <header class="bg-white border-b sticky top-0 z-50 shadow-sm">
      <div class="max-w-screen-2xl mx-auto px-8 py-5 flex items-center justify-between">
        <div class="flex items-center gap-4">
          <img src="@/images/logo/Ecole Ronsard.png" alt="Logo" class="h-11 w-auto">
          <div>
            <h1 class="text-2xl font-bold text-gray-900">Ecole Ronsard ERP</h1>
            <p class="text-sm text-gray-500">Central Administration</p>
          </div>
        </div>

        <div class="flex items-center gap-6">
          <div class="relative w-80">
            <input 
              type="text" 
              placeholder="Search across modules..." 
              class="w-full bg-gray-100 border border-gray-200 rounded-full py-3 pl-12 focus:outline-none focus:border-blue-500"
            >
            <i class="fas fa-search absolute left-5 top-3.5 text-gray-400"></i>
          </div>

          <button class="relative p-3 hover:bg-gray-100 rounded-2xl transition">
            <i class="fas fa-bell text-xl text-gray-600"></i>
            <span class="absolute top-1 right-1 bg-red-500 text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center">3</span>
          </button>

          <div class="flex items-center gap-3 pl-6 border-l">
            <div class="text-right">
              <p class="font-semibold">{{ user?.name || 'Administrator' }}</p>
              <p class="text-xs text-emerald-600">Super Admin</p>
            </div>
            <div class="w-10 h-10 bg-blue-600 text-white rounded-2xl flex items-center justify-center font-bold">
              {{ user?.name?.charAt(0) || 'A' }}
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="max-w-screen-2xl mx-auto px-8 py-10">
      <!-- Welcome -->
      <div class="mb-12">
        <h2 class="text-4xl font-bold text-gray-900">
          Welcome back, {{ user?.name?.split(' ')[0] || 'Admin' }}!
        </h2>
        <p class="text-gray-600 mt-2 text-lg">
          Manage all departments and modules from this central portal
        </p>
      </div>

      <!-- Departments Grid -->
      <div class="mb-8">
        <h3 class="text-2xl font-semibold text-gray-800">Departments &amp; Modules</h3>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
        
        <ModuleCard
          title="Administration"
          description="System overview, user control and full platform access"
          icon="🛠️"
          color="violet"
          route="/admin-dashboard"
        />

        <!-- Human Resources -->
        <ModuleCard
          title="Human Resources"
          description="Staff management, payroll, leave, recruitment and HR operations"
          icon="👥"
          color="secondary"
          route="/hrdashboard"
        />

        <!-- Academics / Teachers -->
        <ModuleCard
          title="Academics"
          description="Teachers management, timetable, subjects, exams and academic records"
          icon="👨‍🏫"
          color="blue"
          route="/teachers-dashboard"
        />

        <!-- IT -->
        <ModuleCard
          title="Information Technology"
          description="System maintenance, support tickets, hardware, software and network"
          icon="💻"
          color="slate"
          route="/itdashboard"
        />

        <!-- Communication -->
        <ModuleCard
          title="Communication"
          description="Internal messaging, announcements, notices and parent communication"
          icon="📢"
          color="emerald"
          route="/comdashboard"
        />

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ModuleCard from '@/components/admin/ModuleCard.vue'

const user = ref({})

onMounted(() => {
  const savedUser = localStorage.getItem('user')
  if (savedUser) {
    user.value = JSON.parse(savedUser)
  }
})
</script>